export function sortByMostRecentlyUpdated<T extends { updatedTimestamp: string }>(arr: T[]): T[] {
  arr.sort((a, b) => {
    const dateA = new Date(a.updatedTimestamp).getTime();
    const dateB = new Date(b.updatedTimestamp).getTime();
    return dateB - dateA;
  });
  return arr;
}
